import React, { Component } from 'react'
import { connect } from 'react-redux';
import Authorizer, { PERMISSIONS, } from '../session/authorizer';
import Authentication from '../../session';
import withRouter from '../lib/withRouter';
import { Button } from 'primereact/button';
import { AddIconInButtonFull, AddUserIcon, ClassetEditIcon, CodeLinkIcon, MailIcon, MoneyIcon } from '../svgIcons';
import { Dialog } from 'primereact/dialog';
import { paymentModes } from '../../constants';
import ClassetInputText from '../../classetComponents/classetInputText';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { getFormFields, isFormValid, onDropDownChange, onTextChange } from '../../utile/formHelper';
import { cloneDeep } from 'lodash';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import Service from '../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import BranchToSectionDD from '../BaseDropdownComponents/BranchToSectionDD';
import { getBranchesLatest } from '../../store/actions';
import { InputSwitch } from 'primereact/inputswitch';



const items = [
    { label: 'Management' },
    { label: 'Transport Management', className: 'ma-active-item' },

];

const home = { icon: 'pi pi-home' }

const payInAmtOrPerOptions = [
    { label: "Amount", value: "amt" },
    { label: "Percentage", value: "per" }
]

const feeConcessionTypesOptions = [
    { value: 'merit', label: 'Merit-based' },
    { value: 'sports', label: 'Sports' },
    { value: 'financial', label: 'Financial Aid' },
    { value: 'alumni', label: 'Alumni' },
    { value: 'staff', label: 'Staff Child' }
];

const createFeeFields = require('./feeConcession.json')

class FeeConcession extends Component {

    constructor(props) {

        super(props);
        this.formFields = getFormFields(createFeeFields);
        this.state = {
            fee: this.formFields.data,
            formValidations: this.formFields.formValidations,
            currentTab: 0,
            concessions: [],
            admissionCategoryOptions: [],
            isDialogOpenForCreateConcession: false,
            feeconcessionStatusObj: {},
            feeTypeOptions: [],
            isStatusChangeDialog: false,
            categoryAssignInfo: [],
            selectedCategoryAssignInfo: [],
            selectAll: false,
            branchId: "",
            boardId: "",
            classId: "",
            sectionId: "",
            feeCategoryOptions: [],
            feeStructureDialog: false,
            newConcession: {},
            allConcessions: []
        };
        this.service = new Service();


    }


    onTabChange = (currentTab) => {
        this.setState({
            currentTab
        })
    }


    async componentDidMount() {

        // await this.props.getBranchesLatest(true);
        await this.getAdmissionCategoryOptions();
        await this.getFeeConcessionsData()


    }




    getFeeConcessionsData = async () => {
        this.setState({ isLoading: true })
        const year = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/concession?academicYear=${year}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                // Store all concessions in allConcessions

                const filteredConcessions = res?.res?.data.filter(
                    concession => concession.branchId === this.state.branchId
                );
                this.setState({
                    allConcessions: res?.res?.data,
                    concessions: filteredConcessions, // Initially empty until branch is selected
                    isLoading: false
                });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Errors In Fetching Data', detail: "", life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false },
                () => this.toast.show({ severity: 'error', summary: 'Errors In Fetching Data', detail: "", life: 3000 })
            );
        }
    };





    getFeeCategoryOptions = async () => {
        if (!this.state.branchId) {
            return; // Don't fetch if no branch is selected
        }

        this.setState({ isLoading: true })
        const year = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/fee-structure?academicYear=${year}&branchId=${this.state.branchId}`;
        try {
            const res = await this.service.get(url, true);


            if (res?.status && res?.res?.data) {
                let responseData = res?.res?.data?.response || res?.res?.data;


                // Filter out schedules without planId (non-installment-based)
                let filteredData = responseData?.filter(el =>
                    el.planId &&
                    el.planId !== null
                );


                this.setState({ feeCategoryOptions: filteredData, isLoading: false });
            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Errors In Fetching Fee Schedules', detail: "", life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Errors In Fetching Fee Schedules', detail: "", life: 3000 });
        }
    }


    getAdmissionCategoryOptions = () => {
        this.setState({ isLoading: true })
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        this.service.get(url, true).then((data) => {
            const options = data?.res?.data?.map((each) => {
                return {
                    label: each?.categoryName,
                    value: each?._id
                }
            })
            if (data?.status && data?.res?.data) {
                this.setState({ admissionCategoryOptions: options, isLoading: false })
            } else {
                this.setState({ isLoading: false })
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while getting the Admission category options', life: 3000 });
            }
        })
    }

    onSelectionChange = (event) => {
        const value = event.value;
        let selectedAll = (value.length === this.state.categoryAssignInfo.length)
        this.setState({
            selectedCategoryAssignInfo: event.value,
            selectAll: selectedAll

        })
    }


    onSelectAllChange = (event) => {
        const selectAll = event.checked;
        if (selectAll) {
            this.setState({
                selectedCategoryAssignInfo: this.state.categoryAssignInfo,
                selectAll: true
            })
        } else {
            this.setState({
                selectedCategoryAssignInfo: [],
                selectAll: false
            })
        }
    };

    onHideAssignDialog = () => {
        this.setState({
            feeStructureDialog: false,
            categoryAssignInfo: [],
            selectedCategoryAssignInfo: [],
            selectAll: false
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if ((prevState.fee?.feeCategories != this.state.fee?.feeCategories) || (prevState.fee?.admissionCategories != this.state.fee?.admissionCategories)) {
            const selectedCategory = this.state.feeCategoryOptions?.find(each => each._id === this.state.fee?.feeCategories)
            
            // Check if we have a selected category and fee categories/admission categories are selected
            if (selectedCategory && this.state.fee?.feeCategories && this.state.fee?.admissionCategories?.length) {
                // Use the new filtering logic instead of the old one
                this.updateFeeTypesBasedOnAdmissionCategory(selectedCategory, this.state.fee.admissionCategories, false);
            } else {
                // Clear fee types if no valid structure or categories
                this.setState({ feeTypeOptions: [] });
            }
        }
    }


    feeStructureAssign = () => {

        let inputKey = this.state?.dropdownsData?.sectionId ? 'user_id' : this.state?.dropdownsData?.classId ? 'sectionId' : 'classId';


        if (this.state.selectedCategoryAssignInfo?.length) {
            let assignInfo = this.state.selectedCategoryAssignInfo?.map((each) => {
                return {
                    [inputKey]: each[inputKey]
                }
            });
            let payload = {
                "branchId": this.state.dropdownsData.branchId,
                "boardId": this.state.dropdownsData.boardId,
                "classId": this.state.dropdownsData.classId,
                "sectionId": this.state.dropdownsData.sectionId,
                "academicYear": localStorage.getItem("userAcademicYear"),
                "feeTypes": this.state.feeconcessionStatusObj?.feeTypes,
                "concessionId": this.state.feeconcessionStatusObj?._id,
                "type": "CON",
                "assignedInfo": assignInfo
            }
            this.setState({ isLoading: true })
            let url = `${baseUrlAdmin}/concession/assign`

            this.service.post(url, payload, true).then(res => {
                if (res?.status && res?.res?.status) {

                    this.setState({
                        isLoading: false,
                        feeStructureDialog: false,
                        feeStructureDetails: '',
                        categoryAssignInfo: [],
                        selectedCategoryAssignInfo: [],
                        selectAll: false

                    }, () => { this.getFeeConcessionsData(); });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            }).catch(err => {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: err.message, life: 3000 });
            })


        }
        else {
            this.toast.show({ severity: 'error', summary: `Assign Records shouldn't not empty`, detail: "Please select Atleast one record", life: 3000 });
        }


    }
    onCreateFeeConcession = async () => {

        const { boardsList, editAdmissionFeeType, fee } = this.state
        let body = cloneDeep(fee)
        const formStatus = isFormValid(createFeeFields, this.formFields.formValidations, body);
        let isCompleteFormValid = true

        // Custom validation for concessionAmount based on amountPercentage
        let customValidations = { ...formStatus.formValidations };

        if (!body.concessionAmount) {
            this.toast.show({ severity: 'error', summary: `Error`, detail: "Please enter concession amount/percentage", life: 3000 });
        }

        if (body.amountPercentage && body.concessionAmount) {
            const amount = parseFloat(body.concessionAmount);

            if (body.amountPercentage === 'per') {
                if (isNaN(amount)) {
                    customValidations.fields.concessionAmount = {
                        isValid: false,
                        errorMsg: 'Please enter a valid number'
                    };
                    customValidations.isFormValid = false;
                    isCompleteFormValid = false;
                } else if (amount > 100) {
                    customValidations.fields.concessionAmount = {
                        isValid: false,
                        errorMsg: 'Percentage cannot exceed 100%'
                    };
                    customValidations.isFormValid = false;
                    isCompleteFormValid = false;
                } else if (amount <= 0) {
                    customValidations.fields.concessionAmount = {
                        isValid: false,
                        errorMsg: 'Percentage must be greater than 0'
                    };
                    customValidations.isFormValid = false;
                    isCompleteFormValid = false;
                }
            } else if (body.amountPercentage === 'amt') {
                if (isNaN(amount)) {
                    customValidations.fields.concessionAmount = {
                        isValid: false,
                        errorMsg: 'Please enter a valid amount'
                    };
                    customValidations.isFormValid = false;
                    isCompleteFormValid = false;
                } else if (amount <= 0) {
                    customValidations.fields.concessionAmount = {
                        isValid: false,
                        errorMsg: 'Amount must be greater than 0'
                    };
                    customValidations.isFormValid = false;
                    isCompleteFormValid = false;
                }
            }
        }

        if (!customValidations.isFormValid) {
            this.setState({ formValidations: customValidations, dateError: true });
            isCompleteFormValid = false;
        }

        if (isCompleteFormValid) {
            const payload =
            {
                "branchId": this.state.branchId,
                "name": body?.concessionName,
                "concessionType": body?.concessionType,
                "isAmtOrPerType": body?.amountPercentage,
                "amtOrPer": body?.concessionAmount,
                "admissionCategories": body?.admissionCategories,
                "feestructures": body?.feeCategories,
                "feeTypes": body?.studentFeeType,
                "academicYear": localStorage.getItem("userAcademicYear"),
                "status": fee?.status,
                "type": "CON"

            }

            const data = fee?._id ? { ...payload, _id: fee?._id } : payload
            let url = `${baseUrlAdmin}/concession/`;
            this.setState({ isLoading: true })
            try {
                const res = await this.service.post(url, data, true);
                if (res?.res?.status && res.status) {
                    this.setState({ isDialogOpenForCreateConcession: false, fee: {}, isLoading: false, });
                    this.getFeeConcessionsData();
                    this.toast.show({ severity: 'success', summary: `Fee Concession has been ${fee?._id ? "updated" : "created"} successfully`, detail: "", life: 3000 });
                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Error', detail: `Error in ${fee?._id ? "update" : "create"} request`, life: 3000 });

                }
            } catch (e) {
                this.setState({ isLoading: false })

                this.toast.show({ severity: 'error', summary: 'Error', detail: `Error in ${fee?._id ? "update" : "create"} request`, life: 3000 });
            }
        }
    }


    handleChangeTheStatusFeeConcession = async () => {
        this.setState({ isLoading: true })
        const { _id, isActiveStatus } = this.state.feeconcessionStatusObj;
        let url = `${baseUrlAdmin}/concession/${_id}/status`;
        try {
            const res = await this.service.put(url, { "status": isActiveStatus }, true);
            if (res?.res?.status && res.status) {
                this.setState({ isStatusChangeDialog: false, feeconcessionStatusObj: {} });
                this.getFeeConcessionsData();
                this.toast.show({ severity: 'success', summary: 'Fee Concession Status has been updated successfully', detail: "", life: 3000 });
            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Error in update Status request', detail: "", life: 3000 });
            }
        } catch (e) {

            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Error in update Status request', detail: "", life: 3000 });
        }
    };


    setDropdownValues = (dropdownsData) => {

        this.setState({
            dropdownsData,
            branchId: dropdownsData?.branchId,
            boardId: dropdownsData?.boardId,
            classId: dropdownsData?.classId,
            sectionId: dropdownsData?.sectionId
        }, () => {
            this.getFeeCategoryAssignInfo(dropdownsData?.branchId, dropdownsData?.boardId, dropdownsData?.classId, dropdownsData?.sectionId);
            this.getFeeCategoryOptions();
            this.getFeeConcessionsData();
        })
    }


    getFeeCategoryAssignInfo = (branchId, boardId, classId, sectionId) => {
        const AcademicYear = localStorage.getItem('userAcademicYear')
        let payload = {
            "branchId": branchId,
            "boardId": boardId,
            "classId": classId,
            "sectionId": sectionId,
            admissionCategory: this.state.feeconcessionStatusObj.admissionCategories

        }
        payload.academicYear = AcademicYear
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/fee-structure/assignInfo`;
        this.service.post(url, payload, true).then(data => {
            if (data?.status) {
                this.setState({
                    categoryAssignInfo: data?.res?.data,
                    isLoading: false

                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching the fee Category Assigninformation', life: 3000 });
            }
        });

    }

    handleEditFeeConcession = async (fee, index) => {

        
        // First, prepare the edit object
        const editObj = {
            ...fee,
            concessionName: fee?.name,
            concessionType: fee?.concessionType,
            amountPercentage: fee?.isAmtOrPerType,
            concessionAmount: fee?.amtOrPer,
            paymentMode: fee?.paymentMode,
            admissionCategories: fee?.admissionCategories,
            feeCategories: fee?.feestructures, // Map from DB field 'feestructures' to form field 'feeCategories'
            studentFeeType: fee?.feeTypes, // This will be the array of IDs
        }



        // Set the fee object and open dialog first
        this.setState({
            fee: editObj,
            isDialogOpenForCreateConcession: true,
            // Ensure branch ID is set for fee category loading
            ...(fee?.branchId && { branchId: fee.branchId })
        }, async () => {
            // After dialog is open, load the fee categories

            
            // If no branch ID is set, try to use the fee's branch ID or skip loading
            if (!this.state.branchId) {

                return;
            }
            
            // Load fee categories if not already loaded
            if (!this.state.feeCategoryOptions || this.state.feeCategoryOptions.length === 0) {
                await this.getFeeCategoryOptions();
            } else {

            }
            

            
            // Then find the selected fee structure (use feestructures from DB)
            const selectedStructure = this.state.feeCategoryOptions.find(
                option => option._id === fee?.feestructures
            );
            

            
            // If we have a structure and admission categories, populate fee types
            if (selectedStructure && fee?.admissionCategories?.length) {

                this.updateFeeTypesBasedOnAdmissionCategory(
                    selectedStructure, 
                    fee.admissionCategories, 
                    false // Don't clear selections during edit
                );
            } else {

            }
        });
    }

    confirm1Change = (e, fee) => {
        this.setState({ isStatusChangeDialog: true, feeconcessionStatusObj: { ...fee, isActiveStatus: e.target.value } })
    };

    addNewConcession = () => {
        this.setState(prevState => ({
            concessions: [...prevState.concessions, { id: Date.now(), label: 'New Concession', description: 'Description here' }]
        }));
    }

    handleChange = (field, value) => {
        this.setState(prevState => ({
            newConcession: {
                ...prevState.newConcession,
                [field]: value
            }
        }));
    }

    updateFeeTypesBasedOnAdmissionCategory = (selectedStructure, admissionCategories, clearInvalidSelections = false) => {
        
        if (!selectedStructure || !admissionCategories?.length) {

            this.setState({
                feeTypeOptions: [],
                ...(clearInvalidSelections && {
                    fee: { ...this.state.fee, studentFeeType: [] }
                })
            });
            return;
        }








        // Get fee type IDs that are NOT one-time from stepTwo
        const nonOneTimeFeeTypeIds = selectedStructure.stepTwo
            ?.filter(stepTwoItem => stepTwoItem.isOneTime === false)
            .map(stepTwoItem => stepTwoItem.feeTypeId) || [];



        // Filter stepOne fee types that are not one-time and match admission categories
        const availableFeeTypes = selectedStructure.stepOne
            ?.filter(feeTypeObj => {
                // Check if this fee type is in the non-one-time list
                const isNonOneTime = nonOneTimeFeeTypeIds.includes(feeTypeObj.feeTypeId);
                
                // Check if any of the selected admission categories match this fee type's admission categories
                const hasMatchingAdmissionCategory = feeTypeObj.admissionType?.some(admissionTypeId => 
                    admissionCategories.includes(admissionTypeId)
                );

                
                return isNonOneTime && hasMatchingAdmissionCategory;
            })
            .map(feeTypeObj => ({
                feeTypeId: feeTypeObj.feeTypeId,
                feeType: feeTypeObj.feeType,
                admissionType: feeTypeObj.admissionType,
                admissionTypes: feeTypeObj.admissionTypes,
                priority: feeTypeObj.priority,
                totalFee: feeTypeObj.totalFee,
            })) || [];



        const mappedFeeTypes = availableFeeTypes.map(feeType => {


            const mappedObj = {
                _id: feeType.feeTypeId,
                feeType: feeType.feeType || 'Unknown Fee Type',
                admissionType: feeType.admissionType,
                admissionTypes: feeType.admissionTypes,
                priority: feeType.priority,
                totalFee: feeType.totalFee
            };


            return mappedObj;
        });



        // Check if we need to clear invalid selections
        const currentFeeSelection = this.state.fee.studentFeeType || [];
        let updatedFeeSelection = currentFeeSelection;

        if (clearInvalidSelections && currentFeeSelection.length > 0) {
            // Get the IDs of the available fee types
            const availableFeeTypeIds = mappedFeeTypes.map(ft => ft._id);

            // Filter out any selected fee types that are no longer available
            updatedFeeSelection = currentFeeSelection.filter(selectedId =>
                availableFeeTypeIds.includes(selectedId)
            );
        }

        this.setState({
            feeTypeOptions: mappedFeeTypes,
            ...(clearInvalidSelections && {
                fee: { ...this.state.fee, studentFeeType: updatedFeeSelection }
            })
        });
    }

    // Custom handler for student fee type selection to store both IDs and labels
    onStudentFeeTypeChange = (selectedIds, fieldName, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss) => {
        
        // First, call the standard dropdown change handler to update the IDs
        onDropDownChange(selectedIds, fieldName, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss);

        // Store the complete objects for proper display (optional - for reference)
        const selectedFeeTypes = this.state.feeTypeOptions.filter(option =>
            selectedIds.includes(option._id)
        );




        // Don't modify the fee state here as onDropDownChange already handles it
        // Just log for debugging purposes
    }

    // Update admission category change to also update fee types
    onAdmissionCategoryChange = (value, fieldName, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss) => {
        // First update the form field
        onDropDownChange(value, fieldName, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss);

        // Use setTimeout to ensure the form field update is processed first
        setTimeout(() => {
            const updatedFee = this.state.fee;

            // Then update fee types if a structure is already selected
            if (updatedFee.feeCategories) {
                const selectedStructure = this.state.feeCategoryOptions.find(
                    (option) => option._id === updatedFee.feeCategories
                );

                if (selectedStructure && value?.length) {
                    this.updateFeeTypesBasedOnAdmissionCategory(selectedStructure, value, false);
                } else {
                    this.setState({
                        feeTypeOptions: [],
                        fee: { ...updatedFee, studentFeeType: [] } // Clear selected fee types
                    });
                }
            } else {
                // Clear fee types when no admission categories are selected
                if (!value?.length) {
                    this.setState({
                        feeTypeOptions: [],
                        fee: { ...updatedFee, studentFeeType: [] }
                    });
                }
            }
        }, 100);
    }

    onChangeFeeStructure = (value, feeCategory, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss) => {
        const selectedOption = this.state.feeCategoryOptions.find(
            (option) => option._id === value
        );

        // Update form field first
        onDropDownChange(value, feeCategory, thisObj, createFeeFields, fee, formValidations, feeFeilds, formValidationss);

        // Use setTimeout to ensure the form field update is processed first
        setTimeout(() => {
            // Get the updated fee object from state
            const updatedFee = this.state.fee;

            // Always clear selected fee types when schedule changes
            const clearedFee = { ...updatedFee, studentFeeType: [] };

            // Then update fee types if admission categories are selected
            if (selectedOption && updatedFee.admissionCategories?.length) {
                this.setState({
                    fee: clearedFee
                }, () => {
                    // Update fee type options after clearing selections
                    this.updateFeeTypesBasedOnAdmissionCategory(selectedOption, updatedFee.admissionCategories, false);
                });
            } else {
                // Clear fee types if no conditions are met
                this.setState({
                    feeTypeOptions: [],
                    fee: clearedFee
                });
            }
        }, 100);
    }

    // Custom validation for concession amount based on amount/percentage type
    onConcessionAmountChange = (value, fieldName, thisObj, createFeeFields, fee, formValidations, feeField, formValidationsField) => {
        // First call the standard text change handler
        onTextChange(value, fieldName, thisObj, createFeeFields, fee, formValidations, feeField, formValidationsField);

        // Apply custom validation based on the selected type
        const updatedValidations = { ...formValidations };

        if (fee.amountPercentage === 'per' && value) {
            const amount = parseFloat(value);
            if (isNaN(amount)) {
                updatedValidations.fields.concessionAmount = {
                    isValid: false,
                    errorMsg: 'Please enter a valid number'
                };
                updatedValidations.isFormValid = false;
            } else if (amount > 100) {
                updatedValidations.fields.concessionAmount = {
                    isValid: false,
                    errorMsg: 'Percentage cannot exceed 100%'
                };
                updatedValidations.isFormValid = false;
            } else if (amount <= 0) {
                updatedValidations.fields.concessionAmount = {
                    isValid: false,
                    errorMsg: 'Percentage must be greater than 0'
                };
                updatedValidations.isFormValid = false;
            } else {
                updatedValidations.fields.concessionAmount = {
                    isValid: true,
                    errorMsg: ''
                };
            }
        } else if (fee.amountPercentage === 'amt' && value) {
            const amount = parseFloat(value);
            if (isNaN(amount)) {
                updatedValidations.fields.concessionAmount = {
                    isValid: false,
                    errorMsg: 'Please enter a valid amount'
                };
                updatedValidations.isFormValid = false;
            } else if (amount <= 0) {
                updatedValidations.fields.concessionAmount = {
                    isValid: false,
                    errorMsg: 'Amount must be greater than 0'
                };
                updatedValidations.isFormValid = false;
            } else {
                updatedValidations.fields.concessionAmount = {
                    isValid: true,
                    errorMsg: ''
                };
            }
        }

        // Update the form validation state if we have custom validation
        if (fee.amountPercentage && value) {
            this.setState({ formValidations: updatedValidations });
        }
    }

    // Custom handler for amount/percentage dropdown change
    onAmountPercentageChange = (value, fieldName, thisObj, createFeeFields, fee, formValidations, feeField, formValidationsField) => {
        // First call the standard dropdown change handler
        onDropDownChange(value, fieldName, thisObj, createFeeFields, fee, formValidations, feeField, formValidationsField);

        // Clear any existing validation errors for concessionAmount and re-validate
        setTimeout(() => {
            if (fee.concessionAmount) {
                this.onConcessionAmountChange(fee.concessionAmount, 'concessionAmount', this, createFeeFields, fee, formValidations, 'fee', 'formValidations');
            }
        }, 100);
    }


    render() {
        const buttonStyle = {
            fontFamily: 'Inter',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: '24px',
            color: "white",
            borderRadius: "8px",
            letterSpacing: '0.25px',
            textAlign: 'left',
            background: 'var(--components-button-secondary-background-default, #076EFF)',
            padding: '5px 25px',
            cursor: 'pointer'
        };
        const { fee, isShowUserInfo, isShowAnalytics, editUser, group, branch, formValidations, newConcession } = this.state




        return (
            <div>
                <div className="admin-management">
                    <div className="col-12 flex justify-content-between align-items-center">
                        <div >
                            <p className="add-vehicle-field-label">
                                Branch<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    optionLabel="name"
                                    optionValue="key"
                                    width="16vw"
                                    value={this.state.branchId}
                                    options={this.props.branchData}
                                    onChange={async (e) => {
                                        const branchId = e.target.value;
                                        // Filter concessions based on selected branch
                                        const filteredConcessions = this.state.allConcessions.filter(
                                            concession => concession.branchId === branchId
                                        );
                                        this.setState({
                                            branchId: branchId,
                                            concessions: filteredConcessions
                                        }, () => this.getFeeCategoryOptions());
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start  align-items-center">
                                            <span className="">Select Branch</span>
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                        <Authorizer permId={PERMISSIONS.CREATE_FEE_CONCESSION} >
                            <div className='col-10 flex justify-content-end align-items-center'>
                                <Button style={{ borderRadius: 10, backgroundColor: '#076EFF' }} onClick={() => {
                                    this.getFeeCategoryOptions(); // Load fee categories when opening dialog
                                    this.setState({ isDialogOpenForCreateConcession: true })
                                }} disabled={this.state.branchId ? false : true}>
                                    <p className=' text-xl'>New Concession</p>
                                    <AddIconInButtonFull width={20} height={20} color={'#E7E3E3'} />
                                </Button>
                            </div>
                        </Authorizer>
                    </div>
                    <div className='grid my-3'>
                        {
                            this.state.concessions.map((fee, index) => {
                                return <div key={index}
                                    className="mx-6 card cursor-pointer col-3 doubts-tab-w"
                                    style={this.state.currentTab === index ? { height: '170px', width: '320px' } : { height: '170px', width: '320px' }}
                                >
                                    <div className="flex flex-column justify-content-center align-items-center ml-3">
                                        <div className='mt-1 w-full flex justify-content-end align-items-center'>
                                            <Authorizer permId={PERMISSIONS.UPDATE_FEE_CONCESSION} >
                                                <div className='-mt-1 mr-3 flex justify-content-end align-items-center' onClick={() => this.handleEditFeeConcession(fee, index)}>
                                                    <ClassetEditIcon width={32} height={32} color={'#000000'} />
                                                </div>
                                            </Authorizer>
                                            <Authorizer permId={PERMISSIONS.UPDATE_FEE_CONCESSION} >
                                                <div className="mr-3">
                                                    <InputSwitch
                                                        className='mt-1'
                                                        onChange={(e) => this.confirm1Change(e, fee)}
                                                        checked={fee?.status} />
                                                </div>
                                            </Authorizer>
                                        </div>
                                        <div className="w-full flex mt-4  ml-3">
                                            <h3 className='card-title'>{fee?.name}</h3>
                                        </div>
                                        <div className="flex justify-content-center mr-5">
                                            <p className='poppins24' style={{ fontSize: '24px' }}>{fee?.studentsCount || 0} Students</p>
                                        </div>
                                        <Authorizer permId={PERMISSIONS.ASSIGN_FEE_CONCESSION} >
                                            <div style={{ marginLeft: 'auto' }} onClick={() => { this.setState({ feeStructureDialog: true, feeconcessionStatusObj: fee }) }} className='-mt-5 d-flex  mr-3 justify-content-end align-items-center'>
                                                <AddUserIcon width={32} height={32} color={'#000000'} />
                                            </div>
                                        </Authorizer>


                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>



                <Dialog
                    visible={this.state.feeStructureDialog}
                    draggable={false}
                    closeOnEscape={false}
                    // position={"right"}
                    // className='ma-alert-box w-3 mr-0'
                    className='assign-dialog-box'
                    style={{ width: "1310px", height: "900px" }}
                    dismissableMask={false}
                    closable={true}
                    header={() => {
                        return (<div className='mt-2'>
                            <h4 className="text-center dialog-header">Fee Structure & Schedule</h4>
                        </div>)
                    }}
                    onHide={() => this.setState({ feeStructureDialog: false })}
                >
                    <div className='ma-scroll-vr-smoke '>
                        <BranchToSectionDD setValues={this.setDropdownValues} />
                        <div className="p-5">
                            <DataTable ref={(el) => this.dt = el}
                                value={this.state.categoryAssignInfo}
                                dataKey={this.state?.dropdownsData?.sectionId ? 'user_id' : this.state?.dropdownsData?.classId ? 'sectionId' : 'classId'}
                                paginator
                                rows={10}

                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"

                                sortable
                                selection={this.state?.selectedCategoryAssignInfo}
                                onSelectionChange={this.onSelectionChange}
                                selectAll={this.state.selectAll}
                                onSelectAllChange={this.onSelectAllChange}
                                selectionMode="checkbox">
                                <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "5rem", height: "5rem" }} alignHeader={"center"} selectionMode="multiple" exportable={false} />
                                <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="branchName" header="Branch" className="datatable-cel" sortable />
                                <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="boardName" header="Board" className="datatable-cel" sortable />
                                <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="className" header="Grade" className="datatable-cel" sortable />
                                {this.state?.dropdownsData?.classId ? <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="sectionName" header="Section Name" className="datatable-cel" sortable /> : <></>}
                                {!this.state?.dropdownsData?.sectionId ? <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="totalStudents" header="Total Students" className="datatable-cel" sortable /> : <></>}
                                {this.state?.dropdownsData?.sectionId ? <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} header="Student Name" className="datatable-cel" sortable
                                    body={(rowData) => {
                                        return (
                                            <p>{rowData?.studentName}</p>
                                        )
                                    }}
                                /> : <></>}
                                {this.state?.dropdownsData?.sectionId ? <Column bodyClassName='text-center' headerClassName="text-color-secondary" style={{ width: "15rem", height: "5rem" }} alignHeader={"center"} field="username" header="Enrollment Id" className="datatable-cel" sortable
                                    body={(rowData) => {
                                        return (
                                            <p>{rowData?.username?.slice(3)}</p>
                                        )
                                    }}
                                /> : <></>}

                            </DataTable>
                        </div >
                        <div className="flex justify-content-center text-center mt-4">
                            <Button label='Assign ' className='confirmDialogAcceptBtn  mr-5 w-15rem' onClick={this.feeStructureAssign} style={{ borderRadius: "12px" }} />
                            <Button className="cancelButtonn px-6" style={{ borderRadius: '10px' }} onClick={this.onHideAssignDialog}>
                                <p className="cancelButtonnText">Cancel</p>
                            </Button>
                        </div>
                    </div>

                </Dialog>

                {this.state.isDialogOpenForCreateConcession && (
                    <style>
                        {`
                            .ma-alert-box .p-dialog-enter-active {
                                transition: transform 300ms ease-out;
                            }
                        `}
                    </style>
                )}

                <Dialog
                    visible={this.state.isDialogOpenForCreateConcession}
                    draggable={false}
                    closeOnEscape={false}
                    position={"right"}
                    className='ma-alert-box'
                    style={{
                        width: "100%",
                        maxWidth: "410px",
                        height: "auto",
                        maxHeight: "90%",
                        // margin: "0 auto"
                    }}
                    dismissableMask={false}
                    closable={true}
                    header={() => {
                        return (<div className='mt-2'>
                            <h4 className="text-center ttext">{`${this.state.fee?._id ? "Update" : "Add"} Concession`} </h4>

                        </div>)
                    }}
                    onHide={() => this.setState({ isDialogOpenForCreateConcession: false, fee: {} })}
                >
                    <div className='flex flex-column justify-content-center mx-3'>

                        <div className="field">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Concession Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    id="concessionName"
                                    className='border-round-md   border-none'
                                    value={fee.concessionName}
                                    onChange={(e) => { onTextChange(e.target.value, 'concessionName', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder="Concession Name" />
                            </div>
                            {formValidations && !formValidations.fields['concessionName'].isValid && <p className="p-error text-lg ">{formValidations.fields['concessionName'].errorMsg}</p>}
                        </div>
                        <div className="field ">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Concession Type<span className='ma-required'>*</span></p>

                            <div className='flex'>
                                <ClassetDropdown
                                    options={feeConcessionTypesOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    className=' no-border text-xl'
                                    value={fee.concessionType}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'concessionType', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder={<p className=''>Select Concession Type</p>}

                                />
                            </div>
                            {formValidations && !formValidations.fields['concessionType'].isValid && <p className="p-error text-lg">{formValidations.fields['concessionType'].errorMsg}</p>}
                        </div>

                        <div className="field ">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Amount/Percentage<span className='ma-required'>*</span></p>

                            <div className='flex'>
                                <ClassetDropdown
                                    options={payInAmtOrPerOptions}
                                    optionLabel="label"
                                    className=' no-border '
                                    value={fee.amountPercentage}
                                    onChange={(e) => { this.onAmountPercentageChange(e.target.value, 'amountPercentage', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder={<p className=''>Select Amount/Percentage</p>}
                                />
                            </div>
                            {formValidations && !formValidations.fields['amountPercentage'].isValid && <p className="p-error text-lg">{formValidations.fields['amountPercentage'].errorMsg}</p>}
                        </div>

                        <div className="field">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Concession Amount/Percentage<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    id="concessionAmount"
                                    className='border-round-md   border-none '
                                    value={fee.concessionAmount}
                                    onChange={(e) => { this.onConcessionAmountChange(e.target.value, 'concessionAmount', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder={fee.amountPercentage === 'per' ? "Enter percentage (max 100%)" : "Enter amount"} />
                            </div>
                            {formValidations && !formValidations.fields['concessionAmount'].isValid && <p className="p-error text-lg ">{formValidations.fields['concessionAmount'].errorMsg}</p>}
                        </div>

                        {/*       <div className="field ">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Payement Mode<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    options={paymentModes}
                                    optionValue="value"
                                    optionLabel="label"
                                    className=' no-border '
                                    value={fee.paymentMode}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'paymentMode', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder={<p className=''>Select Payment Modes</p>}
                                />
                            </div>
                            {formValidations && !formValidations.fields['paymentMode'].isValid && <p className="p-error text-lg">{formValidations.fields['paymentMode'].errorMsg}</p>}
                        </div> */}

                        <div className="field ">
                            <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Admission Categories<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetMultiSelect
                                    options={this.state.admissionCategoryOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    className=' no-border '
                                    value={fee.admissionCategories}
                                    onChange={(e) => { this.onAdmissionCategoryChange(e.target.value, 'admissionCategories', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                    placeholder={<p className=''>Select Admission Category</p>}
                                />
                            </div>
                            {formValidations && !formValidations.fields['admissionCategories'].isValid && <p className="p-error text-lg">{formValidations.fields['admissionCategories'].errorMsg}</p>}
                        </div>
                        {fee.admissionCategories?.length ?
                            <>
                                <div className="field ">
                                    <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Fee Schedule<span className='ma-required'>*</span></p>
                                    <div className='flex'>
                                        <ClassetDropdown
                                            options={this.state.feeCategoryOptions}
                                            optionLabel="scheduleName"
                                            optionValue="_id"
                                            className=' no-border text-xl'
                                            value={fee.feeCategories}
                                            onChange={(e) => this.onChangeFeeStructure(e.target.value, 'feeCategories', this, createFeeFields, fee, formValidations, 'fee', 'formValidations')}
                                            placeholder={<p className=''>Select Fee Schedule</p>}

                                        />
                                    </div>
                                    {formValidations && !formValidations.fields['feeCategories'].isValid && <p className="p-error text-lg">{formValidations.fields['feeCategories'].errorMsg}</p>}
                                </div>

                                <div className="field ">
                                    <p className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Student Fee Type<span className='ma-required'>*</span></p>
                                    <div className='flex'>
                                        <ClassetMultiSelect
                                            options={this.state.feeTypeOptions}
                                            optionLabel="feeType"
                                            optionValue="_id"
                                            className=' no-border '
                                            value={fee.studentFeeType}
                                            onChange={(e) => { this.onStudentFeeTypeChange(e.target.value, 'studentFeeType', this, createFeeFields, fee, formValidations, 'fee', 'formValidations') }}
                                            placeholder={<p className=''>Select Student Fee Type</p>}
                                        />
                                    </div>
                                    {formValidations && !formValidations.fields['studentFeeType'].isValid && <p className="p-error text-lg">{formValidations.fields['studentFeeType'].errorMsg}</p>}
                                </div>
                            </> : <></>}

                        <div className="mt-3" style={{ display: 'flex', }}>
                            <Button className='mr-2' style={{ borderRadius: 10, backgroundColor: '#076EFF', width: '170%', padding: 0, justifyContent: 'center', alignItems: 'center' }} onClick={() => this.onCreateFeeConcession()}>
                                <AddIconInButtonFull width={20} height={20} color={'#E7E3E3'} />
                                <p className='text-xl ml-2'>{`${this.state.fee?._id ? "Update" : "Add"}`}</p>
                            </Button>
                            <Button className='border-none' style={{ borderRadius: 10, backgroundColor: '#E0E0E0', color: "black", width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { this.setState({ isDialogOpenForCreateConcession: false, fee: {} }) }}>
                                <p className=' text-xl'>Cancel</p>
                            </Button>
                        </div>

                    </div>
                </Dialog>
                <Dialog
                    header={<div className='flex justify-content-center align-items-center'>
                        <i className="pi pi-exclamation-triangle text-center text-7xl text-red-400"></i>
                    </div>}
                    visible={this.state.isStatusChangeDialog}
                    style={{ width: '400px', height: "350px" }}
                    onHide={() => { this.setState({ isStatusChangeDialog: false, feeconcessionStatusObj: {} }) }}>
                    <div className="flex flex-column align-items-center surface-overlay border-round">
                        <h4 className="font-bold text-2xl block mb-2 mt-4" >
                            Confirmation ?
                        </h4>
                        <p className="mb-0 text-base">
                            {`Are you sure you want to Change The status `}
                            <span className='text-color text-base font-semibold'> {this.state.feeconcessionStatusObj.isActiveStatus ? "InActive to Active" : "Active to InActive"} </span>For the
                            <span className='p-error text-xl mt-1 font-semibold'>{` ${this.state.feeconcessionStatusObj.name}`}</span>?
                        </p>
                        <div className="flex align-items-center gap-2 mt-4">
                            <Button
                                label="Change"
                                onClick={() => { this.handleChangeTheStatusFeeConcession() }}
                                className="confirmDialogAcceptBtn"
                            ></Button>
                            <Button
                                label="Cancel"
                                outlined
                                onClick={() => { this.setState({ isStatusChangeDialog: false, feeconcessionStatusObj: {} }) }}
                                className="confirmDialogCancelBtn"
                            ></Button>
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {(this.state.isLoading) && <LoadingComponent />}

            </div >
        )
    }
}

const mapStatesToProps = (state) => ({
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level === 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._id
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(FeeConcession)));

